import { apiFetch } from './client';
import type { LeaveSummary } from '$lib/types';

// leaveSummaryApi is the employee-facing GET /api/leave/summary — own data
// only (see internal/api/handlers/leave.go's LeaveSummary), backing the
// Dashboard's "Your leave" card.
export const leaveSummaryApi = {
  get: () => apiFetch<LeaveSummary>('/leave/summary')
};
